module.exports = __webpack_public_path__ + "img/weixin_zf.6754cef8.jpg";